import { render, staticRenderFns } from "./ConfirmationScreen.vue?vue&type=template&id=dd9be98a&scoped=true&"
import script from "./ConfirmationScreen.vue?vue&type=script&lang=js&"
export * from "./ConfirmationScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9be98a",
  null
  
)

export default component.exports